import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["picker", "start", "end", "form"]

    connect() {
        this.fp = flatpickr(this.pickerTarget, {
            mode: "range",
            dateFormat: "Y-m-d",
            defaultDate: [this.startTarget.value, this.endTarget.value],
            onChange: (selectedDates, dateStr, instance) => {
                if (selectedDates.length === 2) {
                    this.startTarget.value = instance.formatDate(selectedDates[0], "Y-m-d")
                    this.endTarget.value = instance.formatDate(selectedDates[1], "Y-m-d")
                    this.submitForm()
                }
            }
        })
    }

    setRange(event) {
        event.preventDefault()
        const days = parseInt(event.currentTarget.dataset.days)
        const end = new Date()
        const start = new Date()
        start.setDate(end.getDate() - days)

        // Set the date in flatpickr, triggering the onChange event which submits the form
        this.fp.setDate([start, end], true)
    }

    submitForm() {
        this.formTarget.requestSubmit()
    }

    disconnect() {
        if (this.fp) {
            this.fp.destroy()
        }
    }
}
